import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import comptabiliteService, { JournalComptable } from '../../api/comptabilite';

const TYPE_LABELS: Record<string, string> = {
  VENTE: 'Ventes',
  ACHAT: 'Achats',
  TRESORERIE: 'Trésorerie',
  OPERATIONS_DIVERSES: 'Opérations diverses',
  A_NOUVEAU: 'À-nouveaux',
};

const Journaux: React.FC = () => {
  const [journaux, setJournaux] = useState<JournalComptable[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setJournaux(await comptabiliteService.listJournaux());
      } catch (e: any) {
        toast.error(e?.response?.data?.message || 'Erreur de chargement');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Journaux comptables</h1>
        <p className="text-sm text-gray-500">Journaux utilisés pour la ventilation des écritures.</p>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600">
            <tr>
              <th className="text-left px-4 py-2 font-medium">Code</th>
              <th className="text-left px-4 py-2 font-medium">Libellé</th>
              <th className="text-left px-4 py-2 font-medium">Type</th>
              <th className="text-left px-4 py-2 font-medium">Compte de trésorerie</th>
              <th className="text-left px-4 py-2 font-medium">État</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} className="px-4 py-6 text-center text-gray-400">Chargement…</td></tr>
            ) : journaux.map((j) => (
              <tr key={j.id} className="border-t border-gray-100 hover:bg-gray-50">
                <td className="px-4 py-2 font-mono font-semibold">{j.code}</td>
                <td className="px-4 py-2">{j.libelle}</td>
                <td className="px-4 py-2">{TYPE_LABELS[j.type] || j.type}</td>
                <td className="px-4 py-2 font-mono">{j.compteTresorerie || '—'}</td>
                <td className="px-4 py-2">
                  <span className={`text-xs px-2 py-0.5 rounded-full ${j.actif ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
                    {j.actif ? 'Actif' : 'Inactif'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Journaux;
